// Shared option lists for the Create Position / Create Cost Center flows.
// Both the picker modals on the homepage and the form pages read from here,
// so the value chosen in the modal can be resolved back to a label on the form.

export const supervisoryOrganizations = [
    { value: 'hr', label: 'Human Resources' },
    { value: 'it', label: 'Information Technologies' },
    { value: 'code', label: 'Software Development' },
    { value: 'pr', label: 'Marketing and PR' },
    { value: 'accounting', label: 'Accounting' }
]

export const reorganizations = [
    { value: 'vcc', label: 'Virtual Career Center' },
    { value: 'stc', label: 'Systems and Technology Center' },
    { value: 'sales', label: 'Sales Center' },
    { value: 'fec', label: 'Further Education Center' },
    { value: 'mfg', label: 'Manufacturing Center' }
]

export const findOption = (options, value) => options.find(option => option.value === value) || null
